import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rmtCurrency',
})
export class RmtCurrencyPipe implements PipeTransform {
  transform(value: string, ..._): string {
    if (!value) {
      return value;
    }

    //todo get currency from symbol somewhere
    const numbersOnly = value.replace(/[^0-9]/g, '');
    return numbersOnly.length > 0 ? `$${numbersOnly}` : '';
  }
}



// WEBPACK FOOTER //
// ./src/pipes/rmt-currency/rmt-currency.ts